export const validateForm = (
  data: any,
  schema: any,
  disabledElements: any = []
) => {
  let errors: any = {};
  for (const field in schema) {
    const {
      type = 'string',
      enumValues,
      subElements,
      min,
      max,
      pattern,
      message,
      required = true,
    } = schema[field];
    const value = data[field];

    if (disabledElements.indexOf(field) !== -1) {
      continue;
    }
    const isEmpty =
      value === undefined ||
      value === '' ||
      (typeof value === 'string' && value.trim() === '');
    if (required && isEmpty) {
      errors[field] = message || `${field} is required`;
      continue;
    }

    if (!required && isEmpty) {
      continue;
    }
    if (type === 'number') {
      const numValue = Number(value);
      if (isNaN(numValue)) {
        errors[field] = `${field} must be a number`;
        continue;
      }
      if (min !== undefined && numValue < min) {
        errors[field] = `${field} must be at least ${min}`;
        continue;
      }
      if (max !== undefined && numValue > max) {
        errors[field] = `${field} cannot exceed ${max}`;
        continue;
      }
    }

    if (type === 'string') {
      if (typeof value !== 'string') {
        errors[field] = `${field} must be a string`;
        continue;
      }
      if (pattern && !pattern.test(value)) {
        errors[field] = message || `${field} format is invalid`;
        continue;
      }
      if (typeof schema[field].custom === 'function') {
        const customError = schema[field].custom(value);
        if (customError) {
          errors[field] = customError;
          continue;
        }
      }
    }

    if (type === 'enum') {
      if (!enumValues?.includes(value)) {
        errors[field] = `${field} must be one of: ${enumValues.join(', ')}`;
        continue;
      }
    }

    if (type === 'boolean') {
      if (typeof value !== 'boolean') {
        errors[field] = `${field} must be a boolean`;
        continue;
      }
      if (!value) {
        continue;
      }
    }

    if (subElements) {
      const subErrors = validateForm(data, subElements, disabledElements);
      if (subErrors) {
        errors = { ...errors, ...subErrors };
      }
    }
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
